<template>
  <div>
    <div class="ui-pannel">
      <p class="title">{{ $t('user.info') }}</p>
      <div class="content">
        <div class="avatar">
          <el-image class="img" :src="user.userPhoto" fit="cover"></el-image>
        </div>
        <div class="info-item">
          <p>
            {{ info.userName
            }}<span v-if="info.sex === 1"><div class="man"></div> </span>
            <span v-else-if="info.sex === 2">
              <div class="women"></div>
            </span>
            <span class="approval" v-if="user.state !== 1">{{
              $t('common.pendingApproval')
            }}</span>
          </p>
          <div class="info">
            <div class="cell">
              <!-- <p>{{$t("form.grade")}}：<span class="txt">高二</span></p> -->
              <p>
                {{ $t('form.birth') }}：<span class="txt">{{
                  info.birthday
                }}</span>
              </p>
              <p>
                {{ $t('school') }}：<span class="txt">{{ info.school }}</span>
              </p>
              <p>
                {{ $t('year') }}：<span class="txt">{{ !!info.schoolYear?currentSchoolYear.find(item=>item.value===info.schoolYear).name:'' }}</span>
              </p>
            </div>

            <div class="btns">
              <a @click="goFill" class="ui-btn">{{ $t('user.complete') }}</a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="ui-pannel" v-if="user.userType === 10 && courseList.length">
      <p class="title">{{$t("user.complete2")}}</p>
      <div class="content">
        <ul class="list">
          <li v-for="(item, index) in courseList" :key="index">
            <div class="photo" @click="goDetail(item)">
              <el-image class="img" :src="item.teacherUserPicUrl" fit="cover"></el-image>
              <span class="tip">{{$t("user.detail")}}</span>
            </div>
            <p class="name">{{item.teacherName}}</p>
            <p class="num">{{item.courseName}}</p>
          </li>
          <li class="more" @click="toMore" v-if="courseList.length >= 6">
            <div class="photo">
              <span class="tip">{{$t("user.more")}}</span>
            </div>
            <p class="name">{{$t("more")}}</p>
          </li>
        </ul>
      </div>
    </div> -->
    <div class="ui-pannel" v-if="user.userType === 10">
      <p class="title">{{ $t('account') }}</p>
      <div class="content account">
        <div class="detail">
          <p class="name">{{ $t('balance') }}：</p>
          <p class="price">US$ {{ balance }}</p>
          <p class="tip">{{ $t('tip') }}</p>
        </div>
        <div class="btns">
          <router-link v-if="user.state === 1" to="/prestore" class="ui-btn">{{
            $t('pay')
          }}</router-link>
          <div
            style="cursor: pointer"
            v-else
            class="ui-btn"
            @click="notReviewedTip = true"
          >
            {{ $t('pay') }}
          </div>
          <el-dialog :visible.sync="notReviewedTip" width="30%">
            <span>{{ $t('common.notReviewedTip') }}</span>
          </el-dialog>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getAmount } from '@/service/api.js'
import { getMyProfile, getStudentStudyCourseList } from '@/service/studentApi.js'
import { getBaseProfile } from '@/service/teacherApi.js'
import moment from 'moment'
export default {
  data() {
    return {
      courseList: [
        { teacherName: 'Amanda', courseLevel: 2, teacherPhotoUrl: require('../assets/demo/photo.png') },
        { teacherName: 'Amanda2', courseLevel: 1, teacherPhotoUrl: require('../assets/demo/photo.png') },
        { teacherName: 'Amanda3', courseLevel: 2, teacherPhotoUrl: require('../assets/demo/photo.png') },
        { teacherName: 'Amanda4', courseLevel: 1, teacherPhotoUrl: require('../assets/demo/photo.png') },
        { teacherName: 'Amanda5', courseLevel: 2, teacherPhotoUrl: require('../assets/demo/photo.png') },
      ],
      balance: "2000.00",
      info: '',
      notReviewedTip: false,
      currentSchoolYear: [
        { name: this.$t('year8'), value: 7 },
        { name: this.$t('year9'), value: 8 },
        { name: this.$t('year10'), value: 9 },
        { name: this.$t('year11'), value: 10 },
        { name: this.$t('year12'), value: 11 },
        { name: this.$t('year13'), value: 12 },
      ]
    }
  },
  computed: {
    user() {
      return JSON.parse(this.$store.getters.GETUSER)
    }
  },
  mounted() {
    console.log(this.user)
    if (this.user.userType === 20) {
      this.getBaseProfile()
    } else {
      this.getMyProfile()
      this.getAmount()
      this.getStudentStudyCourseList()
    }
  },
  methods: {
    async getBaseProfile() {
      let res = await getBaseProfile({ teacherId: this.user.uid })
    },
    async getMyProfile() {
      let res = await getMyProfile()
      if (res.data.status === 1) {
        this.info = res.data
        this.info.birthday = this.info.birthday !== 0 ? moment(this.info.birthday, "YYYYMMDD").format("DD/MM/YYYY") : '';
      }
    },
    async getStudentStudyCourseList() {
      let res = await getStudentStudyCourseList({ state: 2, pageNO: 1, pageSize: 6, totalCount: 0, studentId: this.user.uid })
      if (res.data.status === 1) {
        this.courseList = res.data.data
      }
    },
    async getAmount() {
      let res = await getAmount()
      if (res.data.status === 1) {
        this.balance = res.data.balance
      }
    },
    goFill() {
      if (this.user.userType === 20) {
        this.$router.push({ path: '/teacherFill', query: { type: 1 } })
      } else {
        this.$router.push({ path: '/studentFill', query: { type: 1 } })
      }
    },
    toMore() {
      this.$router.push({ path: '/user/myteacher' })
    },
    goDetail(item) {
      this.$router.push({ path: '/teachers/teacherDetail', query: { id: item.teacherId } })
    }
  }
}
</script>
<style lang="scss" scoped>
.man {
  width: 24px;
  height: 24px;
  background-image: url(../assets/man.png);
  background-repeat: no-repeat;
  background-position: 0px 5px;
  background-size: cover;
  display: inline-block;
  margin-left: 5px;
}
.women {
  width: 24px;
  height: 24px;
  background-image: url(../assets/women.png);
  background-repeat: no-repeat;
  background-position: 0px 5px;
  background-size: cover;
  display: inline-block;
  margin-left: 5px;
}
.content {
  display: flex;
  padding: 50px;
}
.avatar {
  width: 150px;
  height: 150px;
  border-radius: 50%;
  overflow: hidden;
  font-size: 0;
  .img {
    width: 100%;
    height: 100%;
  }
}
.info-item {
  flex: 1;
  padding: 18px 0 0 40px;
  font-size: 18px;
  .tag {
    display: inline-block;
    padding: 0 14px;
    border-radius: 24px;
    height: 24px;
    line-height: 24px;
    background: #a9c4b1;
    color: #fff;
    margin-left: 20px;
    font-size: 14px;
  }
  .waiting {
    background: #a0a0a0;
  }
}
.info {
  display: flex;
  p {
    margin-top: 20px;
  }
  .txt {
    color: #555;
  }
  .cell {
    width: 230px;
  }
  .btns {
    flex: 1;
    text-align: center;
  }
}
.list {
  display: flex;
  margin-left: -25px;
  li {
    margin: 0 25px;
    padding-bottom: 20px;
    text-align: center;
  }
  .photo {
    width: 90px;
    height: 90px;
    border-radius: 50%;
    overflow: hidden;
    font-size: 0;
    position: relative;
    cursor: pointer;
    .img {
      width: 100%;
      height: 100%;
    }
    .tip {
      position: absolute;
      left: 0;
      right: 0;
      bottom: 0;
      height: 35px;
      line-height: 35px;
      text-align: center;
      font-size: 14px;
      color: #fff;
      background: rgba($color: #2680eb, $alpha: 0.55);
      display: none;
    }
    &:hover .tip {
      display: block;
    }
  }
  .name {
    margin-top: 10px;
    line-height: 21px;
    font-size: 18px;
  }
  .num {
    line-height: 19px;
    color: #555;
  }
  .more {
    .photo {
      background: url(../assets/more.png);
    }
    .name {
      margin-top: 20px;
    }
  }
}
.account {
  .detail {
    width: 485px;
  }
  .name {
    color: #333;
    line-height: 21px;
    font-size: 18px;
  }
  .price {
    margin-top: 20px;
    font-size: 42px;
    line-height: 55px;
  }
  .tip {
    color: #555;
    margin-top: 20px;
  }
  .btns {
    padding-top: 47px;
  }
}
.complete,
.waiting {
  padding: 30px 50px 40px 0;
  text-align: center;
  flex: 1;
  .name {
    font-size: 16px;
    line-height: 24px;
  }
  .num {
    margin-top: 10px;
    font-size: 42px;
    line-height: 55px;
    font-weight: bold;
  }
}
.complete {
  color: #a9c4b1;
  .el-icon-success {
    font-size: 24px;
    vertical-align: top;
    margin-right: 10px;
  }
}
.waiting {
  color: #ffa40e;
  .name:before {
    content: '';
    display: inline-block;
    width: 24px;
    height: 24px;
    background: url(../assets/waiting.png);
    vertical-align: top;
    margin-right: 10px;
  }
}
.summary {
  .line {
    height: 50px;
    margin-top: 50px;
    border-left: 1px dashed #ddd;
    width: 1px;
  }
}
.approval {
  background: #a9c4b1;
  height: 42px;
  line-height: 42px;
  font-size: 14px;
  padding: 3px 20px;
  border-radius: 10px;
  margin-left: 20px;
  color: #fff;
}
</style>
<i18n>
{
  "cn": {
    "account": "帐户情况",
    "balance": "账户余额",
    "tip": "付款时将优先使用余额付款，余额不足时使用 Paypal 或信用卡全额付款",
    "pay": "去预存",
    "more": "更多老师",
    "school":"就读学校",
    "year":"学年",
    "year8":"初中一年級",
    "year9":"初中二年級",
    "year10":"初中三年級",
    "year11":"高中一年級",
    "year12":"高中二年級",
    "year13":"高中三年級"
  },
  "TW": {
    "account": "帳戶情况",
    "balance": "帳戶餘額",
    "tip": "付款時將優先使用餘額付款，餘額不足時使用Paypal或信用卡全額付款",
    "pay": "去預存",
    "more": "更多老師",
    "school":"就读学校",
    "year":"学年",
    "year8":"國中一年級",
    "year9":"國中二年級",
    "year10":"國中三年級",
    "year11":"高中一年級",
    "year12":"高中二年級",
    "year13":"高中三年級"
  },
  "en": {
    "account": "My account ",
    "balance": "Remaining balance ",
    "tip": "If there is sufficient credit in your account, payment will be automatically effected from your account balance; if your account balance is insufficient, full payment will be effected via PayPal or credit card.",
    "pay": "Top-up credit ",
    "more": "More",
    "school":"School",
    "year":"Year",
    "year8":"Year 8",
    "year9":"Year 9",
    "year10":"Year 10",
    "year11":"Year 11",
    "year12":"Year 12",
    "year13":"Year 13"
  }
}
</i18n>